import { useSearchParams } from 'react-router';
import { URLStateType } from '@/enums/url-state-type.enums';

/**
 * Pure URL fetcher hook for environment search parameter
 * @returns A tuple containing the current URL environment value and a setter function
 */
export function useEnvironmentUrlState(): [string | null, (environment: string) => void] {
    const [searchParams, setSearchParams] = useSearchParams();

    const urlEnvironment = searchParams.get(URLStateType.ENVIRONMENT);

    const setEnvironment = (newEnvironment: string): void => {
        setSearchParams(
            (prevParams) => {
                const params = new URLSearchParams(prevParams);
                params.set(URLStateType.ENVIRONMENT, newEnvironment);
                return params;
            },
            { replace: true },
        );
    };

    return [urlEnvironment, setEnvironment];
}
